import { makeRequest } from 'utils/requestLogger';

export default (id, email) =>
  makeRequest('post', `/api/courses/${id}/add-student-to-course`, email);


// WEBPACK FOOTER //
// ./src/app/services/courses/addStudentToCourse.js